import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ServiceError } from '../api'
import * as auth from '../auth'
import { LoginCard } from '../carta/LoginCard'
import { useT } from '../i18n/LocaleProvider'

export function PasswordChangeRoute({ onLeave }: { onLeave: () => void }): JSX.Element {
  const t = useT()
  const navigate = useNavigate()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [again, setAgain] = useState('')
  const [failure, setFailure] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const mismatched = again !== '' && newPassword !== again

  async function submit(event: React.FormEvent): Promise<void> {
    event.preventDefault()
    setBusy(true)
    setFailure(null)
    try {
      await auth.change(currentPassword, newPassword)
      auth.forget()
      navigate('/login', { replace: true })
    } catch (error) {
      setFailure(
        error instanceof ServiceError ? error.message : t('password.failed'),
      )
    } finally {
      setBusy(false)
    }
  }

  return (
    <LoginCard title={t('password.title')}>
      <p>{t('password.lead')}</p>
      <form onSubmit={(event) => void submit(event)}>
        <p>
          <label>
            {t('password.current')}{' '}
            <input
              name="current-password"
              type="password"
              autoComplete="current-password"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
            />
          </label>
        </p>
        <p>
          <label>
            {t('password.next')}{' '}
            <input
              name="new-password"
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
            />
          </label>
        </p>
        <p>
          <label>
            {t('password.confirm')}{' '}
            <input
              name="confirm-password"
              type="password"
              autoComplete="new-password"
              value={again}
              onChange={(event) => setAgain(event.target.value)}
            />
          </label>
        </p>
        {mismatched && (
          <p role="alert" className="guasto">
            {t('password.mismatch')}
          </p>
        )}
        <p>
          <button
            className="primario"
            type="submit"
            disabled={
              busy ||
              currentPassword === '' ||
              newPassword === '' ||
              again === '' ||
              mismatched ||
              newPassword === currentPassword
            }
          >
            {busy ? t('password.busy') : t('password.submit')}
          </button>{' '}
          <button type="button" onClick={onLeave} disabled={busy}>
            {t('chrome.signOut')}
          </button>
        </p>
      </form>
      {failure !== null && (
        <p role="alert" className="guasto">
          {failure}
        </p>
      )}
    </LoginCard>
  )
}
